import { Container } from 'react-bootstrap';
import * as Sentry from '@sentry/react';
import styles from './ErrorPage.module.css';

function ErrorPage({error}) {
  Sentry.captureException(error);
  return (
    <Container className={styles.ErrorPage}>
      <h1>This page failed to load...</h1>
      <p className={"fw-bold"}>
        The data might be unavailable or an error occurred. Please try again later.
      </p>
      Error Message:
        <pre className={"bg-light border border-light p-2 rounded"}>{error.message}</pre>
      <p>
        If the problem persists, please contact <a href="mailto:support@townsville.today">support@townsville.today</a> and report this fault.
      </p>
    </Container>
  )
}

export default ErrorPage
